module.exports = __webpack_public_path__ + "img/blog-4-2.8b045d35.webp";